<script setup>
import { FilterList } from "@easy/ui/filters";
import { ref } from "vue";
import { i18n } from "@/i18n";
import { useI18n } from "vue-i18n";
import { useFilterList } from "@/shared/utils/useFilterList";

const { t } = useI18n();
const lang = ref(i18n.global.locale.value);
const pageSize = defineModel("pageSize", { required: true });
const filtersData = ref([
    {
        name: "perPage",
        label: t("shared.filters.per_page"),
        value: pageSize,
        options: [
            { label: "10", value: 10 },
            { label: "20", value: 20 },
            { label: "50", value: 50 },
            { label: "100", value: 100 },
        ],
    },
]);
const { applyFilter } = useFilterList(filtersData);
</script>

<template>
    <div class="flex items-center lg:py-3 lg:px-6 lg:space-x-6 border-b ct-border-2">
        <div class="flex-grow">
            <FilterList
                :filters="filtersData"
                :lang="lang"
                :label="$t('shared.filters.title')"
                @select="applyFilter"
            />
        </div>
    </div>
</template>
